export default {
    EMAIL: 'email',
    PASSWORD: 'password',
};
